<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <private-keys-form-global :mode="mode" :readonly="!isEditable" v-model="privateKeysConfig" v-else></private-keys-form-global>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('details')">
            <span>{{ $t('common.cncl') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('edit')">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="deletePrivateKey">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="editPrivateKey">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
          <b-button variant="primary"
            @click="createPrivateKey">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'PrivateKeysForm',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'private-keys-form-global': PrivateKeysFormGlobal,
    'spinner' : Spinner
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      activateSpinner: false,
      certificate: '',
      currentPrivateKey: {},
      privateKeysConfig: {},
      formType: 'add',
      pageTitle: ''
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_private_key')
    if(this.id !== '-1' && (this.mode === "view" || "edit")) {
      this.getPrivateKey()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    createPrivateKey(){
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        name: this.privateKeysConfig.name,
        privateKey: this.privateKeysConfig.privateKey,
        password: this.privateKeysConfig.password,
        passwordVerif: this.privateKeysConfig.passwordVerif,
        type: this.privateKeysConfig.type,
        idPod: this.privateKeysConfig.idPod
      }
      this.$engine.firstOn().security.private_keys.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.priv_key_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/2'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(this.$t('common.security.priv_key_addition_error'))
      })
    },
    deletePrivateKey(){
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.priv_key_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.firstOn().security.private_keys.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.priv_key_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/2'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.priv_key_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editPrivateKey(){
      let that = this
      let params = {
        id: this.id,
        name: this.privateKeysConfig.name,
        privateKey: this.privateKeysConfig.privateKey,
        password: this.privateKeysConfig.password,
        passwordVerif: this.privateKeysConfig.passwordVerif,
        type: this.privateKeysConfig.type,
        idPod: this.privateKeysConfig.idPod
      }
      this.$engine.firstOn().security.private_keys.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.priv_key_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/2'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.priv_key_edit_error'))
      })
    },
    fillFields () {
      this.privateKeysConfig = this.currentPrivateKey
      this.activateSpinner = false
    },
    formHasError () {
      if (this.privateKeysConfig.name === undefined || this.privateKeysConfig.name.length === 0) {
        this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
        return true
      }
      if (this.privateKeysConfig.privateKey === undefined || this.privateKeysConfig.privateKey.length === 0) {
        this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
        return true
      }
      if (this.privateKeysConfig.type === undefined || this.privateKeysConfig.type === "0") {
        this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
        return true
      }
      /* if (this.privateKeysConfig.password === undefined || this.privateKeysConfig.password.length === 0) {
        this.okMessageBox(this.$t('common.security.password_missing'))
        return true
      }
      if (this.privateKeysConfig.passwordVerif === undefined || this.privateKeysConfig.passwordVerif.length === 0) {
        this.okMessageBox(this.$t('common.security.password_verify_missing'))
        return true
      } */
      if (this.privateKeysConfig.passwordVerif !== this.privateKeysConfig.password) {
        this.okMessageBox(this.$t('common.security.passwords_not_matching'))
        return true
      }
      if (this.privateKeysConfig.idPod === undefined || this.privateKeysConfig.idPod === '') {
        this.okMessageBox(this.$t('common.security.pod_missing'))
        return true
      }
      return false
    },
    getPrivateKey () {
      let that = this
      this.$engine.firstOn().security.private_keys.fetch({id: this.id})
      .then(resp => {
        let that = this
        let privateKeysList = {}

        privateKeysList = resp.data.privateKeys
        that.updatePrivateKey(privateKeysList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      this.formType = mode
    },
    updatePrivateKey(privateKeysList){
      this.currentPrivateKey = privateKeysList[0]
      this.fillFields()
    }
  }
}

</script>
